import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;
  width: 100%;
  max-width: 1170px;
`

export const Services = styled.div`
  display: flex;
  justify-content: center;

  gap: 32px;
  flex-wrap: wrap;
`
